import React from "react";
import {
  CPButton,
  CustomisedTertiaryButton,
} from "../../constants/common/StyledGlobalConstants";
import { useTranslation } from "react-i18next";
import { Modal } from "@vds/modals";
import styled from "styled-components";
import { connect } from "react-redux";
import RedesignedModal from "../common/RedesignedModal";
import PropTypes from "prop-types";

const MobileBreakPoint = 481;
const TabletBreakPoint = 680;
const TextWrapper = styled.p`
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : "neue-haas-grotesk-text")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "")};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "")};
  margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : "")};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : "")};
  padding: ${(props) => (props.padding ? props.padding : "")};
`;

export const StyledModalBox = styled(Modal)`
  min-height: ${(props) => props.mobHeight};
  height: ${(props) => props.mobHeight};
  max-height: ${(props) => props.mobMaxHeight};
  width: ${(props) => props.mobWidth};
  max-width: ${(props) => (props.mobMaxWidth ? props.mobMaxWidth : "initial")};
  box-shadow: 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12), 0px 11px 15px -7px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: ${(props) => (props.padding ? props.padding : "24px 24px 24px 18px")};
  & h2 {
    font-family: "neue-haas-grotesk-display";
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
  }
  & h4 {
    font-family: "neue-haas-grotesk-text";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    @media (max-width: 767px) {
      margin-top: 0 !important;
    }
  }
  .footer {
    display: flex;
    width: 100%;
    justify-content: end;
  }
  @media (max-width: 767px) {
    min-height: ${(props) => (props.userLang === "nl-NL" || props.userLang === "en-US" ? "12.25rem" : props.mobHeight)};
  }
`;

const LoseUnsavedChanges = ({ open, onClose, yesButtonId, noButtonId, onYesButtonClick, windowSize, addComment, modalType, ...props }) => {
  const { t } = useTranslation("casesTranslation");
  return (
    
      <RedesignedModal
        opened={open}
        onClickClose={onClose}
        modalType={modalType}
        title={addComment === true ? t("Do you want to leave this page?") : t("Leave this page?")}
        ariaLabel={addComment === true ? "Do you want to leave this page?" : "Leave this page?"}
        button={
          <>
            <CustomisedTertiaryButton
              ariaLabel="Stay"
              id={noButtonId}
              onClick={onClose}
              buttonWidth={windowSize.width < MobileBreakPoint ? "100%" : "autoTight"}
              buttonHeight={"40px"}
              fontSize={"14px"}
            >
              {t("STAY")}
            </CustomisedTertiaryButton>
            <CPButton
              width="autoTight"
              id={yesButtonId}
              buttonHeight={"40px"}
              buttonWidth={windowSize.width < MobileBreakPoint ? "100%" : "autoTight"}
              ariaLabel="Leave"
              boxButton={true}
              onClick={onYesButtonClick}
              style={{ height: "2.5rem" }}
              fontSize={"14px"}
            >
              {t("LEAVE")}
            </CPButton>
          </>
        }
      >
        <TextWrapper
          fontStyle="normal"
          fontWeight="400"
          fontSize="14px"
          lineHeight="20px"
          marginBottom="0"
          marginTop="0"
          aria-label={addComment === true ? "Your changes have not been submitted and will be lost." : "Your changes will not be made."}
        >
          {addComment === true ? t("Your changes have not been submitted and will be lost.") : t("Your changes will not be made.")}
        </TextWrapper>
      </RedesignedModal>
    
  );
};

LoseUnsavedChanges.defaultProps = {
  open: false,
  primaryButtonId: "",
  secondaryButtonId: "",
  windowSize: {},
  addComment: false,
};

const mapStateToProps = (state) => {
  return {
    userLanguage: state.ACCOUNT.userLanguage,
  };
};

LoseUnsavedChanges.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  yesButtonId: PropTypes.string,
  noButtonId: PropTypes.string,
  onYesButtonClick: PropTypes.func,
  windowSize: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  addComment: PropTypes.bool,
  modalType: PropTypes.string,
  primaryButtonId: PropTypes.string,
  secondaryButtonId: PropTypes.string,
};

export default connect(mapStateToProps)(LoseUnsavedChanges);
